import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumActivityRiskProfile, EnumActivityType, useDeleteActivityMutation, useListFlatGeographiesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Activity',
  setup: function setup(__props) {
    var _useDeleteActivityMut = useDeleteActivityMutation(),
      deleteActivity = _useDeleteActivityMut.mutate,
      loading = _useDeleteActivityMut.loading;
    var _useListFlatGeographi = useListFlatGeographiesQuery(),
      result = _useListFlatGeographi.result;
    var geographies = computed(function () {
      var _result$value;
      return (result === null || result === void 0 ? void 0 : (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listGeographies) || [];
    });
    var getGeographyById = function getGeographyById(id) {
      var _geographies$value$fi, _geographies$value, _geographies$value$fi2;
      return (_geographies$value$fi = (_geographies$value = geographies.value) === null || _geographies$value === void 0 ? void 0 : (_geographies$value$fi2 = _geographies$value.find(function (_ref) {
        var geoId = _ref.id;
        return geoId === id;
      })) === null || _geographies$value$fi2 === void 0 ? void 0 : _geographies$value$fi2.label) !== null && _geographies$value$fi !== void 0 ? _geographies$value$fi : '';
    };
    return {
      __sfc: true,
      deleteActivity: deleteActivity,
      loading: loading,
      result: result,
      geographies: geographies,
      getGeographyById: getGeographyById,
      EnumActivityRiskProfile: EnumActivityRiskProfile,
      EnumActivityType: EnumActivityType
    };
  }
});